import { GetterTree } from "vuex";
import { TasksState, TaskLibrary, TaskType } from "./types";
import { RootState } from "../types";
import { TasksService } from "@/services/tasks.service";
import { TaskTypeId } from "@/types/Tasks/TaskTypeId";

const tasksService = new TasksService(); // @todo modify service to return instance not class

export const getters: GetterTree<TasksState, RootState> = {
	// @refactor to be part of event state
	getEventTasks: state => tasksService.responseToModel(state.Tasks),
	getTasks: state => state.Tasks, // gets event-specific tasks

	// Tasks / Actions - related getters
	getTaskLibrary: state => state.TaskLibrary,
	getTaskTypes: state => state.TaskTypes,
	getTaskLibraryByCategoryID: state => {
		// @todo refactor this entire getter
		const tasksByCategoryID = {};
		let categoryKey = null;
		state.TaskLibrary.forEach((t: any) => {
			if (t.taskCategoryID === 0 || t.taskCategoryID === undefined) {
				categoryKey = 0;
			} else {
				categoryKey = t.taskCategoryID;
			}
			if (!tasksByCategoryID[categoryKey]) {
				tasksByCategoryID[categoryKey] = [];
			}
			tasksByCategoryID[categoryKey].push(t);
		});
		return tasksByCategoryID;
	},
	getSelectedActions: state => {
		const selected: any[] = [];

		state.TaskCategories.forEach((category: any) => {
			category.tasks.forEach((action: any) => {
				if (action.selected) {
					selected.push(action);
				}
			});
		});

		return selected;
	},
	/**
	 * Returns a map of Task Type titles by their task type id.
	 * @param state The Task State
	 * @param getters The Task Getters
	 */
	getTaskTitlesByType: (state, getters) => {
		let taskTypes: Map<TaskTypeId, string> = new Map<TaskTypeId, string>();
		getters.getEnabledActionTypes.forEach((type: TaskType) => {
			taskTypes.set(type.taskTypeID, type.title);
		});
		return taskTypes;
	},

	// Task / Action Categories - related getters
	getTaskCategories: state => state.TaskCategories,

	// Action Plan - related getters
	getActionPlans: state => state.ActionPlans,
	getOutstandingRequiredTasks: state => state.OutstandingRequiredTasks,
	toggleActionListModal: state => state.ToggleActionListModal,
	getNotificationServers: state => state.NotificationServers,
	getNotificationTemplates: state => state.NotificationTemplates,
	getEditTriggerAction: state => state.EditTriggerAction,
	getActionById(state) {
		return actionId => state.TaskLibrary.find((action: TaskLibrary) => action.taskID == actionId);
	},
	/**
	 * Gets a list of enabled action (task) types based on what features are enabled.
	 * The Basic, Input, Yes/No, Dispatch, Url & Assessment Complete tasks do not require feature flags to use
	 * @param state The Task State
	 * @param getters The Task Getters
	 * @param rootState The Root State
	 * @param rootGetters The Root Getters
	 */
	getEnabledActionTypes: (state: TasksState, getters, rootState: RootState, rootGetters) => {
		return state.TaskTypes.filter(task => {
			switch (task.taskTypeID) {
				case TaskTypeId.MassNotification:
					return rootGetters.getFeature(["Actions","MassNotification"]);
				case TaskTypeId.Choices:
					return rootGetters.getFeature(["Actions", "Choices"]);
				case TaskTypeId.CallContact:
					return rootGetters.getFeature(["Actions","CallContacts"]);
				case TaskTypeId.SitRep:
					return rootGetters.getFeature(["Actions", "SitRep"]);
				case TaskTypeId.CCure:
					return rootGetters.getFeature(["Actions", "CCure"]);
				case TaskTypeId.Audit:
					return rootGetters.getFeature(["Actions", "ViewAudit"])
				case TaskTypeId.DynamicDataList:
					return rootGetters.getFeature(["Actions", "DynamicDataList"]);
				case TaskTypeId.ControlRelay:
					return rootGetters.getFeature(["Actions", "Control"]);
				case TaskTypeId.RaiseToCases:
					return rootGetters.getFeature(["CaseManagement", "RaiseToCaseManagement"]);
				case TaskTypeId.EventOutcome:
					return rootGetters.getFeature(["Actions", "EventOutcome"]);
				case TaskTypeId.Basic:
				case TaskTypeId.Input:
				case TaskTypeId.YesNo:
				case TaskTypeId.Dispatch:
				case TaskTypeId.Url:
				case TaskTypeId.AssessmentComplete:
					return true;
				default:
					return false;
			}
		});
	},
	/**
	 * Gets the list of enabled task types and filters out any types specified in ignoreTaskTypes.
	 * @param state The Task State
	 * @param getters The Task Getters
	 * @return A function that takes in an array of TaskTypeIds returns a list with those task types filtered out from the enabled task types list
	 */
	getEnabledActionTypesFilter: (state: TasksState, getters) =>
		(ignoreTaskTypes: TaskTypeId[] = []) => getters.getEnabledActionTypes.filter(x => !ignoreTaskTypes.includes(x.taskTypeID))
	,
	getCallContacts: state => state.CallContacts,
	getDynamicDatalist: state => state.DynamicDataList,
	getDynamicData: state => state.DynamicData,
	/**
	 * If the current event has an event outcome task
	 * @param state The tasks state
	 */
	hasEventOutcomeTask: (state: TasksState) => state.Tasks.some(task => task.taskTypeID == TaskTypeId.EventOutcome),
	getTaskTriggersByTaskId: (state: TasksState) => (taskId: number) => {
		return state.taskTriggers
			.filter(taskTrigger => taskTrigger.taskID == taskId)
	},
	getTaskById: state => (taskId: number) => state.TaskLibrary.find(task => task.taskID == taskId),
};
